import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { ContextService } from 'app/core/services/context.service';
import { MatErrorMessagesDirective } from 'app/shared/directives';
import { TrailerLocationType } from 'app/shared/enums';
import { SitesService } from 'app/shared/services';
import { map, mergeMap, of } from 'rxjs';

@Component({
  selector: 'app-trailer-types',
  imports: [
    MatChipsModule,
    TranslateModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatErrorMessagesDirective,
  ],
  templateUrl: './trailer-types.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrailerTypesComponent {
  @Input() public onlyReefer!: boolean;
  @Input() public controlName!: string;
  @Input() public form!: FormGroup;
  @Input() public hiddenLocations: TrailerLocationType[] = [];
  @Input() public defaultLocation!: TrailerLocationType;
  @Input() public disabled = false;

  private sitesService = inject(SitesService);
  private contextService = inject(ContextService);
  private destroyRef = inject(DestroyRef);
  public trailerTypes$ = this.contextService.siteId
    .pipe(mergeMap((siteId) => (siteId ? this.sitesService.getTrailerTypes(siteId) : of(null))))
    .pipe(
      map((res) =>
        this.onlyReefer
          ? res?.value?.trailerTypesResponse?.filter((type) => type.isReefer)
          : res?.value?.trailerTypesResponse,
      ),
    )
    .pipe(takeUntilDestroyed(this.destroyRef));

  public get inputControl(): AbstractControl<string> | null {
    return this.form.get(this.controlName);
  }
}
